import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../CSS/Inscription.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import api from "../../components/api";
import { Link } from "react-router-dom";

const Connexion = ({ setIsAuthenticated, isAuthenticated }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  // const [isAuthenticated, setIsAuthenticated] = useState(false); // Gestion de l'authentification
  const navigate = useNavigate();

  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    setEmailError(
      !emailRegex.test(value) ? "Veuillez entrer un email valide." : "",
    );
  };

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);
    setPasswordError(
      value.length < 6
        ? "Le mot de passe doit comporter au moins 6 caractères."
        : "",
    );
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!email || !password) {
      alert("Veuillez remplir tous les champs");
      return;
    }

    setLoading(true);

    try {
      const response = await api.post("/connexion", { email, password });
      const { token, user } = response.data;

      // 1. Stockage immédiat
      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user));

      // 2. Mise à jour de l'état (Note: cette opération est asynchrone !)
      setIsAuthenticated(true);

      // 3. ARRÊTER le loading avant de partir
      setLoading(false);

      // 4. Redirection avec replace pour éviter les retours en arrière buggés
      console.log("Tentative de redirection vers dashboard...");
      navigate("/dashboard", { replace: true });
    } catch (error) {
      setLoading(false); // Toujours désactiver en cas d'erreur
      const message =
        error.response?.data?.message || "Erreur lors de la connexion.";
      alert(message);
    }
  };

  return (
    <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center bg-light p-3 p-lg-5">
      <div className="container">
        <div className="row g-0 shadow-lg rounded overflow-hidden">
          {/* BLOC FORMULAIRE */}
          {!isAuthenticated && (
            <div
              className="col-12 col-lg-6 bg-white p-4 p-md-5 d-flex flex-column justify-content-center"
              style={{ minHeight: "450px" }}
            >
              <Link
                to="/"
                className="text-decoration-none text-muted mb-4 d-inline-flex align-items-center link-hover"
              >
                <i className="bi bi-arrow-left me-2"></i>{" "}
                {/* Si vous utilisez Bootstrap Icons */}← Retour à l'accueil
              </Link>
              <h2
                className="text-center fw-bold mb-4"
                style={{ color: "#f5721e" }}
              >
                Connexion
              </h2>

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label fw-semibold">Email</label>
                  <input
                    type="email"
                    className={`form-control form-control-lg ${emailError ? "is-invalid" : ""}`}
                    placeholder="nom@exemple.com"
                    value={email}
                    onChange={handleEmailChange}
                  />
                  {emailError && (
                    <div className="invalid-feedback">{emailError}</div>
                  )}
                </div>

                <div className="mb-4 position-relative">
                  <label className="form-label fw-semibold">Mot de passe</label>
                  <div className="input-group">
                    <input
                      type={showPassword ? "text" : "password"}
                      className={`form-control form-control-lg ${passwordError ? "is-invalid" : ""}`}
                      placeholder="Votre mot de passe"
                      value={password}
                      onChange={handlePasswordChange}
                    />
                    <span
                      className="input-group-text bg-transparent border-start-0"
                      style={{ cursor: "pointer" }}
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      <FontAwesomeIcon
                        icon={showPassword ? faEye : faEyeSlash}
                        className="text-muted"
                      />
                    </span>
                    {passwordError && (
                      <div className="invalid-feedback d-block">
                        {passwordError}
                      </div>
                    )}
                  </div>
                </div>

                {loading ? (
                  <button
                    className="btn btn-warning btn-lg w-100 shadow-sm"
                    type="button"
                    disabled
                  >
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Connexion en cours...
                  </button>
                ) : (
                  <button
                    type="submit"
                    className="btn btn-lg w-100 text-white shadow-sm mb-3"
                    style={{ backgroundColor: "#f5721e", border: "none" }}
                  >
                    Se connecter
                  </button>
                )}
              </form>

              <div className="text-center mt-3 text-muted">
                Vous n'avez pas de compte ?{" "}
                <Link
                  to="/inscription"
                  className="text-decoration-none fw-bold"
                  style={{ color: "#f5721e" }}
                >
                  Inscrivez-vous ici
                </Link>
              </div>
            </div>
          )}

          {/* BLOC IMAGE (Visible uniquement sur Large Desktop) */}
          <div className="col-lg-6 d-none d-lg-block p-0">
            <img
              src="/images/COMMANDO.png"
              className="w-100 h-100"
              alt="Login illustration"
              style={{ objectFit: "cover", minHeight: "450px" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Connexion;
